import './slider-item.scss';

import * as React from 'react';

interface Props {
  children: React.ReactNode;
  refItem: (element: HTMLLIElement) => void;
  styles: {};
}

const SliderItem = (props: Props) => {
  const {children, refItem, styles} = props;
  return (
    <li className="slider-item" ref={refItem} style={styles}>
      {children}
    </li>
  );
};


export default SliderItem;
